<!-- prettier-ignore -->
<div class="form-container">
  @if(pdfsByCategories()?.length > 0) {
    <cicerone-add-pdf [categories]="pdfsByCategories()" />
  }
  <send-route [isSaveRoute]="authService.userValue" [isInfoRoute]="true" />
</div>
